// Frescura del contenido generado a diario (carta do dia, horóscopo, frase, ranking).
// EG_BUILD_DATE la inyecta gatsby-node.js (fecha del build en horario de Brasil).
// Si el generador no corrió, mejor no mostrar nada que mostrar una fecha vieja.
const BUILD_DATE = process.env.EG_BUILD_DATE || null

const toDays = iso => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""))
  return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) / 86400000 : null
}

// Días transcurridos entre la fecha del contenido y el build (Infinity si no se sabe).
export const daysOld = iso => {
  const a = toDays(iso)
  const b = toDays(BUILD_DATE)
  return a === null || b === null ? Infinity : b - a
}

export const isFreshDaily = iso => daysOld(iso) <= 1   // hoy o ayer
export const isFreshWeekly = iso => daysOld(iso) <= 7  // esta semana
